import React from "react";
import { FaChevronDown, FaChevronRight, FaCircleInfo } from "react-icons/fa6";
import { CATEGORY_LABELS } from "./constants";
import { formatTs } from "./format";

// clickable card header: id badge, domain, updated time, found count
export default function RecordHeader({ record, expanded, onToggle }) {
  const foundCount = record.stages.filter((s) => s.found).length;
  const Chevron = expanded ? FaChevronDown : FaChevronRight;

  return (
    <div className="card-header bg-body d-flex align-items-center gap-3 py-3" role="button">
      <Chevron className="text-secondary flex-shrink-0" onClick={onToggle} />
      <div>
        <div className="d-flex align-items-center flex-wrap gap-2">
          <span className="badge fs-6 text-bg-primary">
            {CATEGORY_LABELS[record.category] || record.category} - {record.id}
          </span>
          <span className="fs-6 mb-0">{record.name}</span>
        </div>

        <div className="small text-secondary mt-1 d-flex flex-wrap gap-2">
          <span>
            <FaCircleInfo className="me-1" />
            Updated {formatTs(record.lastUpdated)}
          </span>
          <span>•</span>
          <span>
            Found in{" "}
            <strong>
              {foundCount}/{record.stages.length}
            </strong>{" "}
            stages
          </span>
        </div>
      </div>
    </div>
  );
}
